import { useState, useEffect } from "react";
import { useWindowSize } from "../../../../hooks/useWindowSize";
import * as Yup from "yup";
import { ProductImagePopUp } from "./ProductImagePopUp";
import { history } from "../../../../shared/_helpers/history";
import LeftArrow from "../../../../assets/icons/left-arrow.png";
import AddImg from "../../../../assets/add-img.svg";
import TrashIcon from "../../../../assets/icons/ic_delete.svg";
import { Formik, FormikProps, Form, Field, ErrorMessage } from "formik";
import { allowNumbersOnly, numberWithCommas } from "../../../../shared/utils";
import DatePicker from "react-datepicker";
import { AlertMsg } from "../../../../shared/components/alert-msg";
import { MultiSelect } from "react-multi-select-component";
import { LoadingItem } from "../../../../shared/components/loading";
import { Variant } from "../../../../types/ProductTypes";
import ProductVarianceModal from "./ProductVarianceModal";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

// const uploadImagesData: any[] = [];
const sizeofFetch = 8;

const getMetadata = async ({ pageProps, payload }: any) => {
  await pageProps.getMetadataAction(payload);
};

const addNewProduct = async ({ pageProps, payload }: any) => {
  await pageProps.createProductAction(payload);
};

const uploadProductImage = async ({ pageProps, payload, otherNames }: any) => {
  await pageProps.uploadProductImageAction(payload, otherNames);
};

const getImagesGallery = async ({ pageProps, payload }: any) => {
  await pageProps.getImageGalleryAction(payload, false);
};

export const InAppContent = ({ pageProps }: any) => {
  const screenResolution: any = useWindowSize();
  const [showImagesModal, setShowImagesModal] = useState(false);
  const [showCatError, setShowCatError] = useState(false);
  const [selectedImagesStore, setSelectedImagesStore] = useState<any[]>([]);
  const [selecteCatsStore, setSelecteCatsStore] = useState<any[]>([]);
  const [catListItems, setCatListItems] = useState<any>();
  const [uploadImagesData, setUploadImagesData] = useState<any[]>([]);
  const [variants, setVariants] = useState<Variant[]>([]);
  const [showAddEditVariantPopup, setShowAddEditVariantPopup] =
    useState<boolean>(false);
  const [editingVariantIndex, setEditingVariantIndex] = useState<number | null>(
    null,
  );
  const [variantToEdit, setVariantToEdit] = useState<Variant | null>(null);

  const [allCatsList, setAllCatsList] = useState<any[]>([]);
  const [allCatsSelected, setAllCatsSelected] = useState<any[]>([]);
  const [startDate, onStartChange] = useState<any>();
  const [endDate, onEndChange] = useState<any>();
  const [isTaxableOption, setIsTaxable] = useState(false);
  const [isDiscountMore, setIsDiscountMore] = useState(false);
  // const otherData =
  let imagesChosen: any = [];

  const modules = {
    toolbar: [
      [{ size: [] }],
      ["bold", "italic", "underline", "strike"],
      [{ color: [] }],
      [{ align: [] }],
      [{ list: "ordered" }, { list: "bullet" }],
      ["image", "link"],
    ],
  };

  const formats = [
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "color",
    "align",
    "list",
    "bullet",
    "image",
    "link",
  ];
  useEffect(() => {
    setShowCatError(false);
    setAllCatsSelected([]);

    getMetadata({
      pageProps,
      // payload: "CLEAR"
    }).then(() => {});

    getImagesGallery({
      pageProps,
      payload: "CLEAR",
    });
    addNewProduct({
      pageProps,
      payload: "CLEAR",
    });
  }, []);

  useEffect(() => {
    if (
      pageProps.getProductMetaDataRequest.request_status ===
      "GET_PRODUCT_META_SUCCESS"
    ) {
      setUploadImagesData([]);
      setSelectedImagesStore([]);
      let catsData: any[] =
        pageProps.getProductMetaDataRequest.request_data.response.categories;

      let catFormated: any[] = catsData.map((each: any) => {
        return { label: each?.name, value: each?.name };
      });

      setAllCatsList(catFormated);
    }
  }, [pageProps?.getProductMetaDataRequest?.request_status]);

  useEffect(() => {
    if (!showImagesModal) {
      setSelectedImagesStore(uploadImagesData);
    }
  }, [showImagesModal]);

  const removeProductImage = (url: any) => {
    let imagesBatch = selectedImagesStore;

    imagesBatch = imagesBatch.filter((itemData: any) => {
      return itemData.url !== url;
    });
    setUploadImagesData([]);
    setUploadImagesData((prev) => [...prev, ...imagesBatch]);

    setSelectedImagesStore(imagesBatch);
  };

  const hideProductImgModal = () => setShowImagesModal(false);

  const handleSubmitProduct = (values: any, helpers: any) => {
    let loggedAccountInfo: any =
      localStorage.getItem("mamiVendorXAuth") || "{}";
    loggedAccountInfo = JSON.parse(loggedAccountInfo);

    let urlsList = selectedImagesStore.map((img: any) => img.url);

    let otherNamesList = selectedImagesStore.map((names: any) => {
      let nameList: any[];

      if (names?.othernames) {
        nameList = names.othernames.map((eachName: any) => eachName);
        return nameList.toString();
      }
      if (names?.otherNames) {
        nameList = names.otherNames.map((eachName: any) => eachName);
        return nameList.toString();
      }
    });

    otherNamesList = otherNamesList.filter((element: any, index: any) => {
      return otherNamesList.indexOf(element) === index;
    });
    otherNamesList = otherNamesList.filter((el: any) => {
      return el != null && el !== "" && el !== undefined && el !== "undefined";
    });

    if (allCatsSelected.length === 0) {
      setShowCatError(true);
      return;
    }

    if (allCatsSelected.length >= 1 && urlsList.length >= 1) {
      setShowCatError(false);
      let chosenCats = allCatsSelected.map((cat: any) => cat.value);
      let formattedStart: any, formattedEnd: any;

      if (startDate && endDate) {
        formattedStart = new Date(startDate.toISOString());
        formattedStart.setDate(formattedStart.getDate());
        formattedStart = formattedStart.toISOString();

        formattedEnd = new Date(endDate.toISOString());
        formattedEnd.setDate(formattedEnd.getDate());
        formattedEnd = formattedEnd.toISOString();
      }

      let payload = {
        storeId: loggedAccountInfo.selectedStore.id,
        name: values.productName.trim(),
        categories: [...chosenCats],
        urls: [...urlsList],
        otherNames: [...otherNamesList],
        description: values.productDesc.trim(),
        sizePerUnit: parseFloat(values.productSize.replace(/,/g, "")),
        availableQuantity: parseInt(values.productQty),
        unitOfMeasureId: parseInt(values.productUnit),
        price: {
          amount: parseFloat(values.productPrice.replace(/,/g, "")),
        },
        isTaxable: isTaxableOption,
        discountPrice: values.addDiscount
          ? {
              amount: parseFloat(values.productDiscountPrice.replace(/,/g, "")),
              startDate: formattedStart,
              endDate: formattedEnd,
            }
          : null,
        isWholesale: values.wholesaleProduct,
        minimumOrderQuantity: values.wholesaleProduct
          ? parseInt(values.minimumOrderQuantity)
          : undefined,
        availability: values.available,
        isReturnable: values.eligibleForReturn,
        returnPeriod: values.eligibleForReturn
          ? values.eligibleForReturnOption
          : undefined,
        variants: values.addVariant ? variants : [],
      };

      addNewProduct({ pageProps, payload });
    }
  };

  let detailsValidationSchema = Yup.object().shape({
    productName: Yup.string().required("Required"),
    productPrice: Yup.string().required("Required"),
    productSize: Yup.string().required("Required"),
    productQty: Yup.string().required("Required"),
    productUnit: Yup.string().required("Required"),
    productTags: Yup.string(),
    addDiscount: Yup.boolean(),
    productDiscountPercent: Yup.string().when("addDiscount", {
      is: (addDiscount: boolean) => addDiscount === true,
      then: Yup.string().required("Required"),
    }),
    productDiscountPrice: Yup.string().when("addDiscount", {
      is: (addDiscount: boolean) => addDiscount === true,
      then: Yup.string().required("Required"),
    }),
    productDiscountStart: Yup.string().when("addDiscount", {
      is: (addDiscount: boolean) => addDiscount === true,
      then: Yup.string().required("Required"),
    }),
    productDiscountEnd: Yup.string().when("addDiscount", {
      is: (addDiscount: boolean) => addDiscount === true,
      then: Yup.string().required("Required"),
    }),
    wholesaleProduct: Yup.boolean(),
    minimumOrderQuantity: Yup.number().when("wholesaleProduct", {
      is: (wholesaleProduct: boolean) => wholesaleProduct === true,
      then: Yup.number().required(),
    }),
    available: Yup.string().matches(/^(1|2|0)$/),
    addVariant: Yup.boolean(),
    eligibleForReturn: Yup.boolean(),
    eligibleForReturnOption: Yup.string().when("eligibleForReturn", {
      is: (eligbleForReturn: boolean) => eligbleForReturn === true,
      then: Yup.string().matches(/^(1|2|0)$/),
    }),
    productDesc: Yup.string().required("Required"),
  });

  let initialValues: any = {
    productName: "",
    productPrice: "",
    productSize: "",
    productQty: "",
    productUnit: "",
    productStatus: "",
    productDesc: "",
    productDiscountPercent: "",
    productDiscountPrice: "",
    productDiscountStart: "",
    productDiscountEnd: "",
    startDate: "",
    endDate: "",
    addDiscount: false,
    wholesaleProduct: false,
    minimumOrderQuantity: "",
    available: "0",
    addVariant: false,
    eligibleForReturnOption: "0",
    eligibleForReturn: false,
  };

  return (
    <div className="inapp-content">
      <div className="page-content form-page">
        {/* {showImagesModal && <ProductImagePop />} */}
        {showImagesModal && (
          <ProductImagePopUp
            pageProps={pageProps}
            showImagesModal={showImagesModal}
            uploadImagesData={uploadImagesData}
            setUploadImagesData={setUploadImagesData}
            catListItems={catListItems}
            hideProductImgModal={hideProductImgModal}
          />
        )}
        {screenResolution?.width <= 767 && (
          <div className="mobile_back_nav">
            <div
              className="left-nav"
              onClick={() => history.replace("/app/my-products")}
            >
              {" "}
              <img src={LeftArrow} alt="" />{" "}
            </div>
            <div className="back_nav_txt">Back to Products</div>
          </div>
        )}

        {pageProps.getProductMetaDataRequest.request_status ===
          "GET_PRODUCT_META_SUCCESS" &&
          allCatsList.length >= 1 && (
            <div className="product-form">
              {screenResolution?.width <= 767 && (
                <div className="other-item-wrap">
                  <div className="heading-text">New Product</div>
                  <div className="heading-msg">
                    Kindly add a new product to your store by filling out the
                    necessary information below
                  </div>
                </div>
              )}
              <Formik
                initialValues={initialValues}
                validationSchema={detailsValidationSchema}
                onSubmit={handleSubmitProduct}
              >
                {(props: FormikProps<any>) => {
                  const {
                    values,
                    touched,
                    errors,
                    setFieldTouched,
                    handleChange,
                    setFieldValue,
                  } = props;
                  return (
                    <Form>
                      <div className="form-wrap">
                        <div className="right-product-form">
                          <div className="product-images-container">
                            <div
                              className={
                                selectedImagesStore.length >= 1
                                  ? "image-control"
                                  : "image-control full"
                              }
                            >
                              <div className="images-label">Product image</div>
                              <div
                                className="product-images"
                                onClick={() => {
                                  let allCatData: any = [];
                                  pageProps.getProductMetaDataRequest.request_data.response.categories.forEach(
                                    (eachCat: any) => {
                                      allCatData.push({
                                        value: eachCat.name,
                                        label: eachCat.name,
                                      });
                                    },
                                  );
                                  imagesChosen.length = 1;
                                  setCatListItems(allCatData);
                                  let payload = `page=1&size=${sizeofFetch}`;
                                  getImagesGallery({ pageProps, payload });

                                  setShowImagesModal(true);
                                }}
                              >
                                <div className="upload-wrap-content">
                                  <img src={AddImg} alt="" />
                                  <div className="upload-txt">
                                    Check <span>MamiMarkets Gallery</span> or{" "}
                                    <span>Upload from your device</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            {selectedImagesStore.length >= 1 && (
                              // (!showImagesModal && selectedImagesStore.length >= 1) &&
                              <div className="all-images-chosen">
                                {selectedImagesStore.map(
                                  (eachImage: any, index: any) => {
                                    return (
                                      <div
                                        className="product-image-wrap"
                                        key={index}
                                      >
                                        <div className="image-actions">
                                          <div className="select-cover">
                                            <input
                                              type="radio"
                                              name="cover-image-select"
                                            />
                                          </div>
                                          <div
                                            className="deleteicon"
                                            onClick={() =>
                                              removeProductImage(eachImage.url)
                                            }
                                          >
                                            <img
                                              src={TrashIcon}
                                              alt=""
                                              className=""
                                            />
                                          </div>
                                        </div>
                                        {/* <img src={eachImage.url} alt="" /> */}
                                        <div
                                          className="product-image-item"
                                          key={index}
                                          // style={{
                                          //     backgroundImage: `url(${eachImage.url})`
                                          // }}
                                        >
                                          <img src={eachImage.url} alt="" />
                                        </div>
                                      </div>
                                    );
                                  },
                                )}
                              </div>
                            )}
                          </div>
                          <div className="uploads-msg">
                            Ensure you use high-quality images that clearly
                            showcase the product. Also note that pictures must
                            be in 450 x 450 dimension. Max file size of 5mb.
                          </div>
                          <div className="form-group thin-bordered-box">
                            <div className="tax-label">
                              Is this product taxable?{" "}
                              <span>Learn more</span>{" "}
                            </div>
                            <div className="all_options">
                              <div className="an_option">
                                <span
                                  className={` custom_radio  ${
                                    isTaxableOption ? "selected_option" : ""
                                  }`}
                                >
                                  <input
                                    onChange={(e) => setIsTaxable(true)}
                                    name="check_taxable"
                                    type="radio"
                                    id="isTaxable"
                                    value="isTaxable"
                                  />
                                </span>
                                <label htmlFor="isTaxable">
                                  <span>Yes</span>
                                </label>
                              </div>
                              <div className="an_option">
                                <span
                                  className={`custom_radio ${
                                    !isTaxableOption ? "selected_option" : ""
                                  }`}
                                >
                                  <input
                                    onChange={(e) => setIsTaxable(false)}
                                    name="check_taxable"
                                    type="radio"
                                    id="notTaxable"
                                    value="notTaxable"
                                  />
                                </span>
                                <label htmlFor="notTaxable">
                                  <span>No</span>
                                </label>
                              </div>
                            </div>
                            <br />
                            <div
                              className={
                                errors.productTags && touched.productTags
                                  ? "invalid-input-wrap"
                                  : ""
                              }
                            >
                              <label
                                htmlFor="productTags"
                                className="tax-label"
                              >
                                Product tags (optional)
                                <ErrorMessage
                                  name="productTags"
                                  className="form-input-error"
                                  component="span"
                                />
                              </label>
                              <Field
                                value={values.productTags}
                                name="productTags"
                                id="productTags"
                                type="text"
                                autoComplete="off"
                                onChange={handleChange}
                                className={`input-wrap inapp-input ${
                                  errors.productTags && touched.productTags
                                    ? "is-invalid-input "
                                    : !errors.productTags &&
                                        values.productTags !== ""
                                      ? "valid-input"
                                      : ""
                                }`}
                              ></Field>
                              <div className="tax-label">
                                Suggested: <span>perishable</span>,{" "}
                                <span>nutritious</span>, <span>delicious</span>
                              </div>
                              {/* <small className="help-text">Maximum of 50 characters</small> */}
                            </div>
                          </div>
                          <br />
                          {screenResolution?.width >= 768 && (
                            <>
                              <div className="add-discount-wrap">
                                <Field
                                  onChange={handleChange}
                                  type="checkbox"
                                  name="addDiscount"
                                  id="addDiscount"
                                />
                                <label htmlFor="addDiscount">
                                  Add a discount
                                </label>
                              </div>
                              {values.addDiscount === true && (
                                <div className="discount-wrap">
                                  <div className="two-sided">
                                    <div className="form-group">
                                      <div
                                        className={
                                          errors.productDiscountPercent &&
                                          touched.productDiscountPercent
                                            ? "invalid-input-wrap "
                                            : ""
                                        }
                                      >
                                        <label htmlFor="productDiscountPercent">
                                          Discount %
                                          {values.productPrice && (
                                            <ErrorMessage
                                              name="productDiscountPercent"
                                              className="form-input-error"
                                              component="span"
                                            />
                                          )}
                                          {!values.productPrice && (
                                            <span className="price-info-txt">
                                              (Enter original price)
                                            </span>
                                          )}
                                        </label>

                                        <Field
                                          // value={values.productDiscountPercent}
                                          disabled={!values.productPrice}
                                          value={allowNumbersOnly(
                                            values.productDiscountPercent,
                                            3,
                                          )}
                                          name="productDiscountPercent"
                                          type="text"
                                          placeholder="Discount %"
                                          // onChange={handleChange}
                                          onChange={(e: any) => {
                                            let valueSet: any =
                                              numberWithCommas(e.target.value);

                                            if (
                                              parseFloat(valueSet) <= 100 ||
                                              e.target.value === ""
                                            ) {
                                              setFieldTouched(
                                                "productDiscountPercent",
                                                true,
                                                true,
                                              );
                                              setFieldValue(
                                                "productDiscountPercent",
                                                valueSet,
                                              );

                                              let originalPrice: any =
                                                parseFloat(
                                                  values.productPrice.replace(
                                                    /,/g,
                                                    "",
                                                  ),
                                                );
                                              valueSet = valueSet.replace(
                                                /,/g,
                                                "",
                                              );

                                              let newProductPrice: any =
                                                (parseFloat(valueSet) / 100) *
                                                parseFloat(originalPrice);
                                              newProductPrice =
                                                parseFloat(originalPrice) -
                                                newProductPrice;
                                              newProductPrice =
                                                Number.parseFloat(
                                                  newProductPrice.toString(),
                                                ).toFixed(2);

                                              setFieldValue(
                                                "productDiscountPrice",
                                                newProductPrice.toString(),
                                              );
                                            }
                                          }}
                                          className={`input-wrap inapp-input ${
                                            errors.productDiscountPercent &&
                                            touched.productDiscountPercent
                                              ? "is-invalid-input "
                                              : !errors.productDiscountPercent &&
                                                  values.productDiscountPercent !==
                                                    ""
                                                ? "valid-input"
                                                : ""
                                          }`}
                                        ></Field>
                                      </div>
                                    </div>
                                    <div className="form-group">
                                      <div
                                        className={
                                          errors.productDiscountPrice &&
                                          touched.productDiscountPrice
                                            ? "invalid-input-wrap "
                                            : ""
                                        }
                                      >
                                        <label htmlFor="productDiscountPrice">
                                          New price
                                          {values.productPrice && (
                                            <ErrorMessage
                                              name="productDiscountPrice"
                                              className="form-input-error"
                                              component="span"
                                            />
                                          )}
                                          {!values.productPrice && (
                                            <span className="price-info-txt">
                                              (Enter original price)
                                            </span>
                                          )}
                                        </label>

                                        <div className="price-wrap">
                                          <span className="currency-pre">
                                            $
                                          </span>
                                          <Field
                                            value={numberWithCommas(
                                              values.productDiscountPrice,
                                            )}
                                            name="productDiscountPrice"
                                            type="text"
                                            disabled={!values.productPrice}
                                            onChange={(e: any) => {
                                              let valueSet: any =
                                                numberWithCommas(
                                                  e.target.value,
                                                );
                                              setFieldTouched(
                                                "productDiscountPrice",
                                                true,
                                                true,
                                              );

                                              setFieldValue(
                                                "productDiscountPrice",
                                                valueSet,
                                              );

                                              if (
                                                parseFloat(valueSet) >=
                                                parseFloat(values.productPrice)
                                              ) {
                                                setIsDiscountMore(true);
                                                setFieldValue(
                                                  "productDiscountPercent",
                                                  "",
                                                );
                                              } else {
                                                setIsDiscountMore(false);
                                                let originalPrice: any =
                                                  parseFloat(
                                                    values.productPrice.replace(
                                                      /,/g,
                                                      "",
                                                    ),
                                                  );
                                                valueSet = valueSet.replace(
                                                  /,/g,
                                                  "",
                                                );

                                                let diff =
                                                    parseFloat(originalPrice) -
                                                    parseFloat(valueSet),
                                                  perCentOffer = Math.round(
                                                    (diff /
                                                      parseFloat(
                                                        originalPrice,
                                                      )) *
                                                      100,
                                                  );

                                                setFieldValue(
                                                  "productDiscountPercent",
                                                  perCentOffer.toString(),
                                                );
                                              }
                                              // setFieldError
                                            }}
                                            // onChange={handleChange}
                                            className={`input-wrap inapp-input ${
                                              errors.productDiscountPrice &&
                                              touched.productDiscountPrice
                                                ? "is-invalid-input "
                                                : !errors.productDiscountPrice &&
                                                    values.productDiscountPrice !==
                                                      ""
                                                  ? "valid-input"
                                                  : ""
                                            }`}
                                          ></Field>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="two-sided">
                                    <div className="form-group">
                                      <div
                                        className={
                                          errors.productDiscountStart &&
                                          touched.productDiscountStart
                                            ? "invalid-input-wrap "
                                            : ""
                                        }
                                      >
                                        <label htmlFor="productDiscountStart">
                                          Start date
                                          <ErrorMessage
                                            name="productDiscountStart"
                                            className="form-input-error"
                                            component="span"
                                          />
                                        </label>

                                        <DatePicker
                                          selected={startDate}
                                          onChange={(date: any) => {
                                            onStartChange(date);
                                            setFieldTouched(
                                              "productDiscountStart",
                                              true,
                                            );
                                            setFieldValue(
                                              "productDiscountStart",
                                              date.toISOString(),
                                            );
                                          }}
                                          minDate={new Date()}
                                          name="productDiscountStart"
                                          // maxDate={new Date()}
                                          placeholderText="Select start date"
                                        />
                                      </div>
                                    </div>
                                    <div className="form-group">
                                      <div
                                        className={
                                          errors.productDiscountEnd &&
                                          touched.productDiscountEnd
                                            ? "invalid-input-wrap "
                                            : ""
                                        }
                                      >
                                        <label htmlFor="productDiscountEnd">
                                          End date
                                          <ErrorMessage
                                            name="productDiscountEnd"
                                            className="form-input-error"
                                            component="span"
                                          />
                                        </label>
                                        <DatePicker
                                          selected={endDate}
                                          onChange={(date: any) => {
                                            onEndChange(date);
                                            setFieldTouched(
                                              "productDiscountEnd",
                                              true,
                                            );
                                            setFieldValue(
                                              "productDiscountEnd",
                                              date.toISOString(),
                                            );
                                          }}
                                          name="productDiscountEnd"
                                          minDate={new Date()}
                                          // maxDate={new Date()}
                                          placeholderText="Select end date"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                              <div className="product-cta">
                                <button
                                  // disabled={pageProps.createStoreProductRequest?.is_request_processing || selecteCatsStore.length < 1 || selectedImagesStore.length < 1}
                                  disabled={
                                    pageProps.createStoreProductRequest
                                      ?.is_request_processing ||
                                    allCatsSelected.length < 1 ||
                                    selectedImagesStore.length < 1
                                  }
                                  className={
                                    pageProps.createStoreProductRequest
                                      ?.is_request_processing ||
                                    allCatsSelected.length < 1 ||
                                    selectedImagesStore.length < 1
                                      ? "btn btn-disabled"
                                      : "btn"
                                  }
                                >
                                  {/* className={pageProps.createStoreProductRequest?.is_request_processing || selecteCatsStore.length < 1 || selectedImagesStore.length < 1 ? "btn btn-disabled" : "btn"}> */}
                                  {pageProps.createStoreProductRequest
                                    .is_request_processing
                                    ? "Please wait..."
                                    : "Add Product"}
                                  {/* {` imgs ${selectedImagesStore.length}`}
                                                {` cats ${selecteCatsStore.length}`} */}
                                </button>
                              </div>
                            </>
                          )}
                          {pageProps?.createStoreProductRequest
                            ?.request_status &&
                            pageProps.createStoreProductRequest
                              .request_status === "CREATE_PRODUCT_FAILURE" && (
                              <AlertMsg
                                type="error"
                                message={
                                  pageProps.createStoreProductRequest
                                    ?.request_data.error
                                }
                              />
                            )}
                          {showCatError && (
                            <AlertMsg
                              type="error"
                              message="Select product category"
                            />
                          )}
                        </div>
                        <div className="product-info">
                          <div className="form-group thin-bordered-box">
                            <div
                              className={
                                errors.productName && touched.productName
                                  ? "invalid-input-wrap"
                                  : ""
                              }
                            >
                              <label htmlFor="productName">
                                Product name
                                <ErrorMessage
                                  name="productName"
                                  className="form-input-error"
                                  component="span"
                                />
                              </label>
                              <Field
                                value={values.productName}
                                name="productName"
                                id="productName"
                                autoComplete="off"
                                type="text"
                                placeholder="Enter product name here"
                                onChange={handleChange}
                                className={`input-wrap inapp-input ${
                                  errors.productName && touched.productName
                                    ? "is-invalid-input "
                                    : !errors.productName &&
                                        values.productName !== ""
                                      ? "valid-input"
                                      : ""
                                }`}
                              ></Field>
                              <small className="help-text">
                                Maximum of 50 characters
                              </small>
                            </div>
                            <br />
                            <div className="">
                              {/* <div className={errors.productName && touched.productName ? "invalid-input-wrap" : ""}> */}
                              <label htmlFor="productName">Category</label>
                              <MultiSelect
                                options={allCatsList}
                                value={allCatsSelected}
                                onChange={setAllCatsSelected}
                                labelledBy="Select"
                                hasSelectAll={false}
                                className="cat-select-wrap"
                                // isLoading={true}
                              />
                            </div>

                            <div className="two-sided for_pricing">
                              <div className="form-group pricing_wrap">
                                <div
                                  className={
                                    errors.productPrice && touched.productPrice
                                      ? "invalid-input-wrap "
                                      : ""
                                  }
                                >
                                  <label htmlFor="productPrice">
                                    Price
                                    <ErrorMessage
                                      name="productPrice"
                                      className="form-input-error"
                                      component="span"
                                    />
                                  </label>

                                  <div className="price-wrap">
                                    <span className="currency-pre">$</span>
                                    <Field
                                      value={numberWithCommas(
                                        values.productPrice,
                                      )}
                                      name="productPrice"
                                      type="text"
                                      placeholder=" Price"
                                      autoComplete="off"
                                      // onChange={handleChange}
                                      onChange={(e: any) => {
                                        let valueSet: any = numberWithCommas(
                                          e.target.value,
                                        );
                                        setFieldTouched(
                                          "productPrice",
                                          true,
                                          true,
                                        );

                                        setFieldValue("productPrice", valueSet);
                                        if (!e.target.value) {
                                          setFieldValue(
                                            "productDiscountPercent",
                                            "",
                                          );
                                          setFieldValue(
                                            "productDiscountPrice",
                                            "",
                                          );
                                        } else {
                                          if (values.productDiscountPercent) {
                                            let disCountPercentvalue: any =
                                                values.productDiscountPercent.replace(
                                                  /,/g,
                                                  "",
                                                ),
                                              originalPrice: any = parseFloat(
                                                valueSet.replace(/,/g, ""),
                                              );

                                            if (
                                              parseFloat(
                                                disCountPercentvalue,
                                              ) <= 100
                                            ) {
                                              let newProductPrice: any =
                                                (parseFloat(
                                                  disCountPercentvalue,
                                                ) /
                                                  100) *
                                                originalPrice;
                                              newProductPrice =
                                                originalPrice - newProductPrice;
                                              newProductPrice =
                                                Number.parseFloat(
                                                  newProductPrice.toString(),
                                                ).toFixed(2);

                                              setFieldValue(
                                                "productDiscountPrice",
                                                newProductPrice,
                                              );
                                            }
                                          }
                                        }
                                      }}
                                      className={`input-wrap inapp-input ${
                                        errors.productPrice &&
                                        touched.productPrice
                                          ? "is-invalid-input "
                                          : !errors.productPrice &&
                                              values.productPrice !== ""
                                            ? "valid-input"
                                            : ""
                                      }`}
                                    ></Field>
                                  </div>
                                </div>
                              </div>
                              <div className="form-group qty_only_wrap">
                                <label htmlFor="productSize">
                                  Size
                                  <ErrorMessage
                                    name="productSize"
                                    className="form-input-error"
                                    component="span"
                                  />
                                </label>
                                <div
                                  className={
                                    (errors.productSize &&
                                      touched.productSize) ||
                                    errors.productUnit
                                      ? "invalid-input qty-input"
                                      : "qty-input"
                                  }
                                >
                                  <div className="input-item">
                                    <Field
                                      value={numberWithCommas(
                                        values.productSize,
                                      )}
                                      name="productSize"
                                      type="text"
                                      autoComplete="off"
                                      placeholder="Size"
                                      onChange={handleChange}
                                      className={` ${
                                        errors.productSize &&
                                        touched.productSize
                                          ? "is-invalid-input "
                                          : !errors.productSize &&
                                              values.productSize !== ""
                                            ? "valid-input"
                                            : ""
                                      }`}
                                    ></Field>
                                  </div>
                                  <Field
                                    value={values.productUnit}
                                    name="productUnit"
                                    as="select"
                                    autoComplete="off"
                                    onChange={handleChange}
                                    placeholder=""
                                    className={`${
                                      errors.productUnit && touched.productUnit
                                        ? "is-invalid-input"
                                        : !errors.productUnit &&
                                            values.productUnit !== ""
                                          ? "valid-input"
                                          : ""
                                    }`}
                                  >
                                    <option value="">size</option>
                                    {pageProps.getProductMetaDataRequest.request_data.response.units.map(
                                      (eachUnit: any, index: any) => {
                                        return (
                                          <option
                                            key={index}
                                            value={eachUnit.id}
                                          >
                                            {eachUnit.unit}
                                          </option>
                                        );
                                      },
                                    )}
                                  </Field>
                                </div>
                              </div>
                            </div>

                            <div className="form-group">
                              <label htmlFor="productQty">
                                Quantity Available
                                <ErrorMessage
                                  name="productQty"
                                  className="form-input-error"
                                  component="span"
                                />
                              </label>
                              <div
                                className={
                                  errors.productQty && touched.productQty
                                    ? "invalid-input-wrap"
                                    : ""
                                }
                              >
                                <Field
                                  value={allowNumbersOnly(values.productQty)}
                                  name="productQty"
                                  type="text"
                                  autoComplete="off"
                                  placeholder="Enter Quantity"
                                  onChange={handleChange}
                                  className={`input-wrap inapp-input ${
                                    errors.productQty && touched.productQty
                                      ? "is-invalid-input "
                                      : !errors.productQty &&
                                          values.productQty == ""
                                        ? "valid-input"
                                        : ""
                                  }`}
                                ></Field>
                              </div>
                            </div>

                            <div className="form-group">
                              <div>
                                <label htmlFor="productDesc">
                                  Description
                                  <ErrorMessage
                                    name="productDesc"
                                    className="form-input-error"
                                    component="span"
                                  />
                                </label>
                                <Field name="productDesc">
                                  {({ field, form }: any) => (
                                    <ReactQuill
                                      value={field.value}
                                      onChange={(val) =>
                                        form.setFieldValue(field.name, val)
                                      }
                                      onBlur={(_, __, quill) => {
                                        const plainText = quill
                                          .getText()
                                          .trim();
                                        if (plainText.length === 0)
                                          form.setFieldValue(field.name, "");
                                        form.setFieldTouched(field.name, true);
                                      }}
                                      modules={modules}
                                      formats={formats}
                                      className={`custom-quill ${
                                        form.errors.productDesc &&
                                        form.touched.productDesc
                                          ? "is-invalid-input"
                                          : !form.errors.productDesc &&
                                              field.value
                                            ? "valid-input"
                                            : ""
                                      }`}
                                    />
                                  )}
                                </Field>
                                <small className="help-text">
                                  Maximum of 500 characters
                                </small>
                              </div>
                            </div>
                          </div>
                          <div className="form-group thin-bordered-box">
                            <div className="wholesale-available-product-box">
                              <div className="whosale-product-box">
                                <div className="checkbox-radio-wrap">
                                  <label>
                                    <Field
                                      onChange={handleChange}
                                      type="checkbox"
                                      name="wholesaleProduct"
                                      id="wholesaleProduct"
                                    />
                                    This is a wholesale product
                                  </label>
                                </div>

                                <div className="min-order-qty-group">
                                  <div
                                    className={
                                      errors.minimumOrderQuantity &&
                                      touched.minimumOrderQuantity
                                        ? "invalid-input-wrap "
                                        : ""
                                    }
                                  >
                                    <Field
                                      type="number"
                                      id="minimumOrderQuantity"
                                      name="minimumOrderQuantity"
                                      disabled={!values.wholesaleProduct}
                                      min={1}
                                      placeholder="Enter minimum order quantity"
                                      className={`input-wrap inapp-input ${
                                        errors.minimumOrderQuantity &&
                                        touched.minimumOrderQuantity
                                          ? "is-invalid-input "
                                          : !errors.minimumOrderQuantity &&
                                              values.minimumOrderQuantity !== ""
                                            ? "valid-input"
                                            : ""
                                      }`}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="availability-group">
                                <span className="availability-label">
                                  Availability
                                </span>
                                <div className="checkbox-radio-wrap">
                                  <label>
                                    <Field
                                      onChange={handleChange}
                                      type="radio"
                                      name="available"
                                      id="available-Pickup"
                                      value="1"
                                      checked={values.available === "1"}
                                    />
                                    Available for Pickup
                                  </label>
                                </div>
                                <div className="checkbox-radio-wrap">
                                  <label>
                                    <Field
                                      onChange={handleChange}
                                      type="radio"
                                      name="available"
                                      id="available-Preorder"
                                      value="2"
                                      checked={values.available === "2"}
                                    />
                                    Pre-order
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="two-shared-box">
                            <div className="form-group thin-bordered-box">
                              <div className="variant-btn-wrapper">
                                <div className="checkbox-radio-wrap">
                                  <label>
                                    <Field
                                      onChange={handleChange}
                                      type="checkbox"
                                      name="addVariant"
                                      id="addVariant"
                                    />
                                    Add/edit variants
                                  </label>
                                </div>
                                <div>
                                  <button
                                    className="input-wrap"
                                    disabled={!values.addVariant}
                                    onClick={() =>
                                      setShowAddEditVariantPopup(true)
                                    }
                                  >
                                    + Add variants option
                                  </button>
                                </div>
                                {values.addVariant && variants.length > 0 && (
                                  <div className="variant-summary">
                                    {variants.map((variant, index) => (
                                      <div key={index} className="variant-card">
                                        <div className="variant-left">
                                          <div>
                                            <div className="variant-label">
                                              Variance {index + 1}
                                              <button
                                                type="button"
                                                className="variant-edit-btn"
                                                onClick={() => {
                                                  setEditingVariantIndex(index);
                                                  setVariantToEdit(variant);
                                                  setShowAddEditVariantPopup(
                                                    true,
                                                  );
                                                }}
                                                title="Edit variant"
                                              >
                                                ✎
                                              </button>
                                            </div>
                                          </div>
                                          <div className="variant-chip-container">
                                            <div className="variant-chip">
                                              {variant.category}:{" "}
                                              {variant.value}
                                            </div>
                                            <div className="variant-chip">
                                              Price: ${variant.price.amount}
                                            </div>
                                            <div className="variant-chip">
                                              Stock Qty: {variant.stockQuantity}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                )}
                              </div>
                            </div>

                            <div className="form-group thin-bordered-box">
                              <div className="eligible-btn-wrapper">
                                <div className="checkbox-radio-wrap">
                                  <label>
                                    <Field
                                      onChange={handleChange}
                                      type="checkbox"
                                      name="eligibleForReturn"
                                      id="eligibleForReturn"
                                    />
                                    Eligible for return
                                  </label>
                                </div>

                                <select
                                  className="input-wrap select"
                                  disabled={!values.eligibleForReturn}
                                >
                                  <option>Select an option</option>
                                  <option
                                    value="0"
                                    selected={
                                      values.eligibleForReturnOption === "0"
                                    }
                                  >
                                    For 3 days.
                                  </option>
                                  <option
                                    value="1"
                                    selected={
                                      values.eligibleForReturnOption === "1"
                                    }
                                  >
                                    For 7 days.
                                  </option>
                                </select>
                              </div>
                            </div>
                          </div>

                          {screenResolution?.width <= 767 && (
                            <>
                              <div className="add-discount-wrap">
                                <Field
                                  onChange={handleChange}
                                  type="checkbox"
                                  name="addDiscount"
                                  id="addDiscount"
                                />
                                <label htmlFor="addDiscount">
                                  Add a discount
                                </label>
                              </div>
                              {values.addDiscount === true && (
                                <div className="discount-wrap">
                                  <div className="two-sided">
                                    <div className="form-group">
                                      <div
                                        className={
                                          errors.productDiscountPercent &&
                                          touched.productDiscountPercent
                                            ? "invalid-input-wrap "
                                            : ""
                                        }
                                      >
                                        <label htmlFor="productDiscountPercent">
                                          Discount %
                                          {values.productPrice && (
                                            <ErrorMessage
                                              name="productDiscountPercent"
                                              className="form-input-error"
                                              component="span"
                                            />
                                          )}
                                          {/* {!values.productPrice &&
                                                                                    <span className="price-info-txt">(Enter original price)</span>
                                                                                } */}
                                        </label>

                                        <Field
                                          // value={values.productDiscountPercent}
                                          disabled={!values.productPrice}
                                          value={allowNumbersOnly(
                                            values.productDiscountPercent,
                                            3,
                                          )}
                                          name="productDiscountPercent"
                                          type="text"
                                          placeholder="Discount %"
                                          // onChange={handleChange}
                                          onChange={(e: any) => {
                                            let valueSet: any =
                                              numberWithCommas(e.target.value);

                                            if (
                                              parseFloat(valueSet) <= 100 ||
                                              e.target.value === ""
                                            ) {
                                              setFieldTouched(
                                                "productDiscountPercent",
                                                true,
                                                true,
                                              );
                                              setFieldValue(
                                                "productDiscountPercent",
                                                valueSet,
                                              );

                                              let originalPrice: any =
                                                parseFloat(
                                                  values.productPrice.replace(
                                                    /,/g,
                                                    "",
                                                  ),
                                                );
                                              valueSet = valueSet.replace(
                                                /,/g,
                                                "",
                                              );

                                              let newProductPrice: any =
                                                (parseFloat(valueSet) / 100) *
                                                parseFloat(originalPrice);
                                              newProductPrice =
                                                parseFloat(originalPrice) -
                                                newProductPrice;
                                              newProductPrice =
                                                Number.parseFloat(
                                                  newProductPrice.toString(),
                                                ).toFixed(2);

                                              setFieldValue(
                                                "productDiscountPrice",
                                                newProductPrice.toString(),
                                              );
                                            }
                                          }}
                                          className={`input-wrap inapp-input ${
                                            errors.productDiscountPercent &&
                                            touched.productDiscountPercent
                                              ? "is-invalid-input "
                                              : !errors.productDiscountPercent &&
                                                  values.productDiscountPercent !==
                                                    ""
                                                ? "valid-input"
                                                : ""
                                          }`}
                                        ></Field>
                                      </div>
                                    </div>
                                    <div className="form-group">
                                      <div
                                        className={
                                          errors.productDiscountPrice &&
                                          touched.productDiscountPrice
                                            ? "invalid-input-wrap "
                                            : ""
                                        }
                                      >
                                        <label htmlFor="productDiscountPrice">
                                          New price
                                          {values.productPrice && (
                                            <ErrorMessage
                                              name="productDiscountPrice"
                                              className="form-input-error"
                                              component="span"
                                            />
                                          )}
                                          {/* {!values.productPrice &&
                                                                                    <span className="price-info-txt">(Enter original price)</span>
                                                                                } */}
                                        </label>

                                        <div className="price-wrap">
                                          <span className="currency-pre">
                                            $
                                          </span>
                                          <Field
                                            value={numberWithCommas(
                                              values.productDiscountPrice,
                                            )}
                                            name="productDiscountPrice"
                                            type="text"
                                            disabled={!values.productPrice}
                                            onChange={(e: any) => {
                                              let valueSet: any =
                                                numberWithCommas(
                                                  e.target.value,
                                                );
                                              setFieldTouched(
                                                "productDiscountPrice",
                                                true,
                                                true,
                                              );

                                              setFieldValue(
                                                "productDiscountPrice",
                                                valueSet,
                                              );

                                              if (
                                                parseFloat(valueSet) >=
                                                parseFloat(values.productPrice)
                                              ) {
                                                setIsDiscountMore(true);
                                                setFieldValue(
                                                  "productDiscountPercent",
                                                  "",
                                                );
                                              } else {
                                                setIsDiscountMore(false);
                                                let originalPrice: any =
                                                  parseFloat(
                                                    values.productPrice.replace(
                                                      /,/g,
                                                      "",
                                                    ),
                                                  );
                                                valueSet = valueSet.replace(
                                                  /,/g,
                                                  "",
                                                );

                                                let diff =
                                                    parseFloat(originalPrice) -
                                                    parseFloat(valueSet),
                                                  perCentOffer = Math.round(
                                                    (diff /
                                                      parseFloat(
                                                        originalPrice,
                                                      )) *
                                                      100,
                                                  );

                                                setFieldValue(
                                                  "productDiscountPercent",
                                                  perCentOffer.toString(),
                                                );
                                              }
                                              // setFieldError
                                            }}
                                            // onChange={handleChange}
                                            className={`input-wrap inapp-input ${
                                              errors.productDiscountPrice &&
                                              touched.productDiscountPrice
                                                ? "is-invalid-input "
                                                : !errors.productDiscountPrice &&
                                                    values.productDiscountPrice !==
                                                      ""
                                                  ? "valid-input"
                                                  : ""
                                            }`}
                                          ></Field>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="two-sided">
                                    <div className="form-group">
                                      <div
                                        className={
                                          errors.productDiscountStart &&
                                          touched.productDiscountStart
                                            ? "invalid-input-wrap "
                                            : ""
                                        }
                                      >
                                        <label htmlFor="productDiscountStart">
                                          Start date
                                          <ErrorMessage
                                            name="productDiscountStart"
                                            className="form-input-error"
                                            component="span"
                                          />
                                        </label>

                                        <DatePicker
                                          selected={startDate}
                                          showIcon={true}
                                          onChange={(date: any) => {
                                            onStartChange(date);
                                            setFieldTouched(
                                              "productDiscountStart",
                                              true,
                                            );
                                            setFieldValue(
                                              "productDiscountStart",
                                              date.toISOString(),
                                            );
                                          }}
                                          minDate={new Date()}
                                          name="productDiscountStart"
                                          // maxDate={new Date()}
                                          placeholderText="Select start date"
                                        />
                                      </div>
                                    </div>
                                    <div className="form-group">
                                      <div
                                        className={
                                          errors.productDiscountEnd &&
                                          touched.productDiscountEnd
                                            ? "invalid-input-wrap "
                                            : ""
                                        }
                                      >
                                        <label htmlFor="productDiscountEnd">
                                          End date
                                          <ErrorMessage
                                            name="productDiscountEnd"
                                            className="form-input-error"
                                            component="span"
                                          />
                                        </label>
                                        <DatePicker
                                          showIcon={true}
                                          selected={endDate}
                                          onChange={(date: any) => {
                                            onEndChange(date);
                                            setFieldTouched(
                                              "productDiscountEnd",
                                              true,
                                            );
                                            setFieldValue(
                                              "productDiscountEnd",
                                              date.toISOString(),
                                            );
                                          }}
                                          name="productDiscountEnd"
                                          minDate={new Date()}
                                          // maxDate={new Date()}
                                          placeholderText="Select end date"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                              <div className="product-cta">
                                <button
                                  // disabled={pageProps.createStoreProductRequest?.is_request_processing || selecteCatsStore.length < 1 || selectedImagesStore.length < 1}
                                  disabled={
                                    pageProps.createStoreProductRequest
                                      ?.is_request_processing ||
                                    allCatsSelected.length < 1 ||
                                    selectedImagesStore.length < 1
                                  }
                                  className={
                                    pageProps.createStoreProductRequest
                                      ?.is_request_processing ||
                                    allCatsSelected.length < 1 ||
                                    selectedImagesStore.length < 1
                                      ? "btn btn-disabled"
                                      : "btn"
                                  }
                                >
                                  {/* className={pageProps.createStoreProductRequest?.is_request_processing || selecteCatsStore.length < 1 || selectedImagesStore.length < 1 ? "btn btn-disabled" : "btn"}> */}
                                  {pageProps.createStoreProductRequest
                                    .is_request_processing
                                    ? "Please wait..."
                                    : "Add Product"}
                                  {/* {` imgs ${selectedImagesStore.length}`}
                                                {` cats ${selecteCatsStore.length}`} */}
                                </button>
                              </div>
                            </>
                          )}

                          {/* {pageProps?.createStoreProductRequest?.request_status
                                                    && pageProps.createStoreProductRequest.request_status === "CREATE_PRODUCT_FAILURE" &&
                                                    <AlertMsg type="error" message={pageProps.createStoreProductRequest?.request_data.error} />
                                                }
                                                {showCatError &&
                                                    <AlertMsg type="error" message="Select product category" />
                                                } */}
                          {/* {selecteCatsStore.map((item: any) => {
                                                    return <pre>{item}</pre>;
                                                })} */}
                        </div>
                      </div>
                    </Form>
                  );
                }}
              </Formik>
            </div>
          )}
        {pageProps.getProductMetaDataRequest.request_status ===
          "GET_PRODUCT_META_PENDING" && <LoadingItem />}
        {showAddEditVariantPopup && (
          <ProductVarianceModal
            show={showAddEditVariantPopup}
            initialEditVariant={variantToEdit}
            editIndex={editingVariantIndex}
            onClose={() => {
              setShowAddEditVariantPopup(false);
              setEditingVariantIndex(null);
              setVariantToEdit(null);
            }}
            variants={variants}
            setVariants={setVariants}
            pageProps={pageProps}
            sizeOfFetch={sizeofFetch}
          />
        )}
      </div>
    </div>
  );
};
